export enum LeoDashboardAnalysisScope {
  ALL = 'all',
  CUSTOM = 'custom',
}
